export default __webpack_public_path__ + "static/media/girl-with-offer@3x.911281f3.png";